import { render, staticRenderFns } from "./EditLogo.vue?vue&type=template&id=e33be87e&lang=pug"
import script from "./EditLogo.vue?vue&type=script&lang=js"
export * from "./EditLogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports